<!-- NOTE: the stickyWrapperClass="mb-2" is added on the <wl-receipt> to match the mb-2 of the last order-step -->
@if (viewModel$ | async; as vm) {
  <wl-receipt
    [title]="rendering.fields.Title.value || ''"
    [sticky]="true"
    stickyWrapperClass="mb-2"
    [wlTrackProduct]="{
      track: vm.selectedProducts,
      trackingConfig: trackProductConfig,
      trackMode: 'product-detail',
    }"
  >
    <ng-template wlReceiptBreakdown>
      @for (product of vm.selectedProducts; track product; let i = $index) {
        <wl-receipt-breakdown-row [hasRightPart]="true">
          <ng-container leftProjection>
            <p class="h4 text-dark mb-1 text-capitalize">
              {{ product.content.title }}
            </p>
            @if (product.content.subTitle) {
              <p class="h5" [class.mb-2]="hasAnyContent(product)">
                {{ product.content.subTitle }}
              </p>
            }
          </ng-container>
          @if (true) {
            <ng-container rightProjection>
              <div class="d-flex">
                @if (
                  rendering.fields.ProductPricePrefixLabel?.value;
                  as prefix
                ) {
                  <span class="text-body-secondary me-1">{{ prefix }}</span>
                }
                <p class="fw-bold">
                  <ng-container
                    *ngTemplateOutlet="
                      product.price % 1 === 0 ? roundedPrice : decimalPrice;
                      context: { $implicit: product }
                    "
                  ></ng-container>
                </p>
                <span
                  class="text-body-secondary"
                  *scText="suffixLabel(product)"
                ></span>
              </div>
            </ng-container>
          }
        </wl-receipt-breakdown-row>
        <wl-receipt-breakdown-row
          [separator]="i < vm.selectedProducts.length - 1"
          [hasRightPart]="false"
        >
          <ng-container leftProjection>
            <wl-generic-offer-info
              [productInfo]="product.content.productInfo"
              [horizontalMargins]="false"
            ></wl-generic-offer-info>
            @if (product.content.usps?.length > 0) {
              <wl-generic-usps
                [usps]="product.content.usps"
                class="d-block"
                [class.pt-2]="product.content.productInfo.length"
              ></wl-generic-usps>
            }
            @if (product.content.text; as description) {
              <wl-rich-text-wrapper
                [field]="{ value: description }"
                [rendering]="rendering"
              >
                <div
                  [class.pt-2]="
                    product.content.productInfo?.length ||
                    product.content.usps?.length
                  "
                ></div>
              </wl-rich-text-wrapper>
            }
          </ng-container>
        </wl-receipt-breakdown-row>
      }
    </ng-template>
    <ng-template wlReceiptConclusion>
      <wl-receipt-breakdown-row [hasRightPart]="true">
        @if (
          allowMultipleProductsSelection &&
            (showPrices$ | async) &&
            (totalPrice$ | async);
          as totalPrice
        ) {
          <ng-container rightProjection>
            <p
              class="mb-0"
              *scText="rendering.fields.ProductTotalPriceLabel"
            ></p>
            <p class="fw-bold">
              {{ totalPrice | currency: 'EUR' : 'symbol' : '1.0-0' }},-
            </p>
          </ng-container>
        }
      </wl-receipt-breakdown-row>
      <wl-receipt-breakdown-row [hasRightPart]="false">
        <ng-container leftProjection>
          <div
            *wlGenericRichText="rendering.fields.ProductSelectionDisclaimer"
          ></div>
        </ng-container>
      </wl-receipt-breakdown-row>
    </ng-template>
  </wl-receipt>
}

<ng-template #roundedPrice let-product>
  {{ product.price | currency: 'EUR' : 'symbol' : '1.0-0' }},-
</ng-template>
<ng-template #decimalPrice let-product>
  {{ product.price | currency: 'EUR' : 'symbol' : '1.0-2' }}
</ng-template>
